import { Button, Heading } from '@simplywallst/ui-core/next';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';

type Props = {
  selectedFileName: string;
  onClose: () => void;
  onReset: () => void;
};

export const ErrorState = ({ selectedFileName, onClose, onReset }: Props) => {
  return (
    <div className="relative rounded-md bg-p-white px-6 py-3">
      <div className="flex justify-end">
        <Button
          variant="subtle"
          onClick={onClose}
          aria-label="Close"
          className="w-10 p-0"
        >
          <CrossSolid fill="spacegray" />
        </Button>
      </div>
      <WarningSolid className="size-10 fill-bad" />
      <Heading as="h2" size="xLarge" className="mt-2">
        Import failed: {selectedFileName}
      </Heading>
      <p className="mt-5 text-sm text-p-white-170">
        We encountered an error while importing your transactions. Please try
        again.
      </p>
      <p className="text-sm text-p-white-170">
        If the error persists{` `}
        <a
          href="http://support.simplywall.st/hc/en-us/requests/new"
          rel="noreferrer nofollow"
          target="_blank"
          className="text-p-white-170"
        >
          get help from our support team.
        </a>
      </p>
      <div className="mt-6 flex justify-end">
        <Button variant="primary" onClick={onReset}>
          Go back
        </Button>
      </div>
    </div>
  );
};
